const resumo_de_alunos_de_transporte_escolar = [
  {
    path: "/resumo-de-alunos-de-transporte-escolar",
    name: "resumo_de_alunos_de_transporte_escolar",
    meta: {
      breadCrumb:
        "Censo Escolar - Relatório de Acompanhamento do Censo Escolar",
      allowedPermissions: ["relatorios_gerar_arquivo_gestor"],
    },
    component: () =>
      import(
        "@/views/ResumoDeAlunosDeTransporteEscolar/ResumoDeAlunosDeTransporteEscolar.vue"
      ),
  },
];

export { resumo_de_alunos_de_transporte_escolar };
